// extracted by mini-css-extract-plugin
export default {"FeedContainer":"FeedContainerImpression_FeedContainer__G1DVa","loader":"FeedContainerImpression_loader__NkY+c","spin":"FeedContainerImpression_spin__P2stG"};